<sh-text color="secondary">
  {{ 'cts.gantry.unitStatus' | translate }}
</sh-text>

@for (legend of legends; track legend.label) {
  <div class="legend-bulet-label" id="{{ legend.id }}">
    <div
      class="cts-step-legend cts-step-legend--{{ legend.classModifier }}"
    ></div>
    <sh-text color="secondary">
      {{ legend.label | translate }}
    </sh-text>
  </div>
}
